import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { HttpService, AAGUID } from '@interticket/core';
import { IGuestToken } from '@core/interfaces/auth/guest-token.interface';
import { IIamSource } from '@core/interfaces/iam/iam-source.interface';
import { map } from 'rxjs/operators';
import { IUserProfile } from '@core/interfaces/user/user-profile.interface';
import { IAdminPartner } from '@core/interfaces/iam/admin-partner.interface';
import { Customer } from '../../models/customer/customer.model';

@Injectable()
export class IamSourceService implements IIamSource {

  private readonly serviceBaseUrl: string = `/${environment.modules.core.iam.version}/iam`;
  private readonly userServiceBaseUrl: string = `/v1/iam-management/user`;

  constructor(
    private httpService: HttpService
  ) { }

  fetchFeatures(): Observable<string[]> {
    return this.httpService.get<{ features: string[] }>(`${this.serviceBaseUrl}/user-partner/feature`)
      .pipe(
        map(({ features }) => features)
      );
  }

  fetchGuestToken(userId?: AAGUID): Observable<IGuestToken> {
    return this.httpService.post<IGuestToken>(`${this.serviceBaseUrl}/auth/web/open`, { userId: userId || null });
  }

  getProfile(): Observable<IUserProfile> {
    return this.httpService.get<IUserProfile>(`${this.userServiceBaseUrl}/me`);
  }

  updateCustomerDatas(customer: Customer): Observable<Response> {
    return this.httpService.put<Response>(`${this.userServiceBaseUrl}/me/web`, customer);
  }

  getAdminPartners(): Observable<IAdminPartner[]> {
    return this.httpService.get<IAdminPartner[]>(`${this.serviceBaseUrl}/user-partner/accessible-admin-partners`);
  }

}
